// Multi-currency formatting helpers.
export const CURRENCY_MAP = {
  INR: { symbol: "₹", locale: "en-IN" },
  USD: { symbol: "$", locale: "en-US" },
  EUR: { symbol: "€", locale: "de-DE" },
  GBP: { symbol: "£", locale: "en-GB" },
  AED: { symbol: "د.إ", locale: "ar-AE" },
  SGD: { symbol: "S$", locale: "en-SG" },
  JPY: { symbol: "¥", locale: "ja-JP" },
  AUD: { symbol: "A$", locale: "en-AU" },
  CAD: { symbol: "C$", locale: "en-CA" },
};

export function currencySymbol(code) {
  return (CURRENCY_MAP[code] || { symbol: code }).symbol;
}

export function formatMoney(amount, code = "INR") {
  const c = CURRENCY_MAP[code] || { symbol: code, locale: "en-US" };
  const n = Number(amount) || 0;
  return `${c.symbol}${n.toLocaleString(c.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Pretty-print a single value for diff display.
export function formatDiffValue(v) {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (Array.isArray(v)) return v.join(", ") || "—";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

// Convert snake_case → Title Case for human-readable diff field labels.
export function humanizeField(k) {
  return (k || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
